import Checkbox from "./Checkbox";

export function RememberMeCheckbox({ onClick, checked }) {
  return <Checkbox onChange={onClick} checked={checked} label="Remember me" />;
}
